import { useEffect, useState } from 'react';
import { Button, Modal, Form, Input, DatePicker, Select as SelectAnt } from 'antd';
import { getApi, postApi } from '../../services/api';
import { useDispatch } from 'react-redux';
import { showSnack } from 'react-redux-snackbar';
import { format } from 'date-fns';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);

const dateFormat = 'DD/MM/YYYY';

const couriers = [
	{
		name: 'India Post',
		trackingUrl: 'https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx',
	},
	{
		name: 'DTDC',
		trackingUrl: 'https://www.dtdc.in/trace.asp',
	},
	{
		name: 'Blue Dart',
		trackingUrl: 'https://www.bluedart.com/tracking',
	},
	{
		name: 'DHL Express',
		trackingUrl: 'https://www.dhl.com/in-en/home/express.html',
	},
	{
		name: 'FedEx',
		trackingUrl: 'https://www.fedex.com/en-in/home.html',
	},
	{
		name: 'Delhivery',
		trackingUrl: 'https://www.delhivery.com/',
	},
	{
		name: 'Ecom Express',
		trackingUrl: 'https://ecomexpress.in/tracking/',
	},
	{
		name: 'XpressBees',
		trackingUrl: 'https://www.xpressbees.com/track',
	},
	{
		name: 'Gati',
		trackingUrl: 'https://www.gati.com/',
	},
	{
		name: 'Professional Couriers',
		trackingUrl: 'http://www.tpcindia.com/track.aspx',
	},
	{
		name: 'Others',
		trackingUrl: '',
	},
];

function ShowDeliveryDetails({ onboarding }) {
	if (!onboarding) {
		return null;
	}

	const deliverDetails = onboarding.metadata.deliverDetails;

	const deliveryAddress = `${deliverDetails.name} ${deliverDetails.mobile}, ${deliverDetails.flat} ${deliverDetails.area} landmark:${deliverDetails.landmark} pincode:${deliverDetails.pincode}`;

	return (
		<div style={{ marginTop: '40px', marginBottom: '20px', fontWeight: '500' }}>
			Shipping Address: {deliveryAddress}
		</div>
	);
}

function MarkDeviceisDelivery({ onboarding, setOnboarding }) {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [form] = Form.useForm();
	const dispatch = useDispatch();

	useEffect(() => {
		form.setFieldValue('courierServiceUsed', onboarding.deliveryInfo.courierServiceUsed);
		form.setFieldValue('awb', onboarding.deliveryInfo.awb);
		form.setFieldValue('expectedDelivery', dayjs(new Date(onboarding.deliveryInfo.expectedDelivery)));

		form.setFieldValue('shippedOn', dayjs(new Date(onboarding.deliveryInfo.shippedOn)));
	}, [onboarding]);
	const showModal = () => {
		setIsModalOpen(true);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const onSave = async (values) => {
		console.log(values, 'values');
		console.log('values', values);
		try {
			const resp = await postApi(
				{ ...values, onboardId: onboarding._id },
				'/assetze/emp-pre-onboarding/mark-delivered'
			);
			if (resp.type === 'success') {
				dispatch(
					showSnack('SUCCESS_API', {
						label: 'Updated and notified candidate for delivery info',
						timeout: 7000,
					})
				);
				handleCancel();
				setOnboarding(resp.data);
			} else {
				dispatch(
					showSnack('ERROR_API_', {
						label: resp.error,
						timeout: 7000,
					})
				);
			}
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<>
			<div>Delivery Status: Out For delivey</div>
			<Button onClick={() => showModal()} type="primary">
				Mark Delivered
			</Button>
			<Modal onCancel={handleCancel} zIndex={10000} title="Mark Delivered!" open={isModalOpen} footer={null}>
				<Form form={form} onFinish={onSave} layout="vertical" hideRequiredMark>
					<Form.Item rules={[{ required: true }]} name="courierServiceUsed" label="Courier Service Used">
						<SelectAnt
							filterOption={false}
							style={{
								width: '100%',
							}}
							placeholder="Courier Service Used"
							options={couriers.map((el) => {
								return { label: el.name, value: el.name };
							})}
							className="filter-select"
							disabled
						/>
					</Form.Item>

					<Form.Item rules={[{ required: true }]} name="awb" label="AWB/Consignment Number/Reference Number">
						<Input placeholder={'AWB/Consignment Number/Reference Number'} disabled />
					</Form.Item>
					<Form.Item rules={[{ type: 'calendar', required: true }]} name="shippedOn" label="Shipped On">
						<DatePicker format={dateFormat} style={{ width: '100%' }} placeholder="Shipped On" disabled />
					</Form.Item>

					<Form.Item
						rules={[{ type: 'calendar', required: true }]}
						name="expectedDelivery"
						label="Expected Delivery Date"
					>
						<DatePicker
							format={dateFormat}
							style={{ width: '100%' }}
							placeholder="Expected Delivery Date"
							disabled
						/>
					</Form.Item>

					<Form.Item rules={[{ type: 'calendar', required: true }]} name="deliveredOn" label="Delivered Date">
						<DatePicker
							format={dateFormat}
							style={{ backgroundColor: 'white', width: '100%' }}
							placeholder="Delivered Date"
						/>
					</Form.Item>
					<Form.Item label={null}>
						<Button type="primary" htmlType="submit">
							Mark Delivered
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
}

function OutForDeliverUpdate({ incident }) {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [form] = Form.useForm();
	const [onboarding, setOnboarding] = useState(null);
	const dispatch = useDispatch();
	async function getOnboardingData() {
		try {
			const resp = await getApi(`/assetze/emp-pre-onboarding/by-ticketid?ticketId=${incident._id}`);
			if (resp.type === 'success') {
				setOnboarding(resp.data);
			} else {
			}
		} catch (e) {
			console.error(e);
		}
	}

	useEffect(() => {
		getOnboardingData();
	}, []);

	const showModal = () => {
		getOnboardingData(incident._id);
		setIsModalOpen(true);
	};

	const handleOk = () => {
		setIsModalOpen(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	const onSave = async (values) => {
		console.log('values', values);
		try {
			const resp = await postApi(
				{ ...values, onboardId: onboarding._id },
				'/assetze/emp-pre-onboarding/update-delivery'
			);
			if (resp.type === 'success') {
				dispatch(
					showSnack('SUCCESS_API', {
						label: 'Updated and notified candidate for delivery info',
						timeout: 7000,
					})
				);
				handleCancel();
				setOnboarding(resp.data);
			} else {
				dispatch(
					showSnack('ERROR_API_', {
						label: resp.error,
						timeout: 7000,
					})
				);
			}
		} catch (e) {
			console.error(e);
		}
	};

	if (incident.issueType !== 'pre-emp-device-selection') {
		return null;
	}

	if (!onboarding) {
		return null;
	}

	if (onboarding.status === 'out-for-delivery') {
		return <MarkDeviceisDelivery onboarding={onboarding} setOnboarding={setOnboarding} />;
	}

	if (onboarding.status === 'delivered') {
		return <div>Delivery Status: Delivered</div>;
	}

	if (onboarding.status === 'done') {
		return (
			<>
				<Button onClick={() => showModal()} type="primary">
					Mark Out For Delivery
				</Button>
				<Modal
					zIndex={10000}
					title="Mark Out For Delivery!"
					open={isModalOpen}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					<ShowDeliveryDetails onboarding={onboarding} />

					<Form form={form} onFinish={onSave} layout="vertical" hideRequiredMark>
						<Form.Item rules={[{ required: true }]} name="courierServiceUsed" label="Courier Service Used">
							<SelectAnt
								filterOption={false}
								style={{
									width: '100%',
								}}
								placeholder="Courier Service Used"
								options={couriers.map((el) => {
									return { label: el.name, value: el.name };
								})}
								className="filter-select"
							/>
						</Form.Item>

						<Form.Item
							rules={[{ required: true }]}
							name="awb"
							label="AWB/Consignment Number/Reference Number"
						>
							<Input placeholder={'AWB/Consignment Number/Reference Number'} />
						</Form.Item>
						<Form.Item rules={[{ type: 'calendar', required: true }]} name="shippedOn" label="Shipped On">
							<DatePicker
								format={dateFormat}
								style={{ backgroundColor: 'white', width: '100%' }}
								placeholder="Shipped On"
							/>
						</Form.Item>

						<Form.Item
							rules={[{ type: 'calendar', required: true }]}
							name="expectedDelivery"
							label="Expected Delivery Date"
						>
							<DatePicker
								format={dateFormat}
								style={{ backgroundColor: 'white', width: '100%' }}
								placeholder="Expected Delivery Date"
							/>
						</Form.Item>
						<Form.Item label={null}>
							<Button type="primary" htmlType="submit">
								Mark Out For Delivery
							</Button>
						</Form.Item>
					</Form>
				</Modal>
			</>
		);
	}
}

export default OutForDeliverUpdate;
